import { MarkerProps, ControlPosition, MapRef } from "react-map-gl/mapbox";
import MapboxGeocoder, { GeocoderOptions } from "@mapbox/mapbox-gl-geocoder";

import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import React, { useEffect, useRef } from "react";

type GeocoderControlProps = Omit<
  GeocoderOptions,
  "accessToken" | "mapboxgl" | "marker"
> & {
  map: MapRef;
  mapboxAccessToken: string;
  marker?: Omit<MarkerProps, "longitude" | "latitude">;

  position: ControlPosition;

  onLoading?: (...args: unknown[]) => void;
  onResults?: (...args: unknown[]) => void;
  onResult?: (evt: {
    result: {
      center: [number, number];
      geometry: { type: string; coordinates: [number, number] };
    };
  }) => void;
  onError?: (e: object) => void;
};

/* eslint-disable complexity,max-statements */
export default function GeoSearch(props: GeocoderControlProps) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const geocoder: MapboxGeocoder = new MapboxGeocoder({
      ...props,
      marker: false,
      clearAndBlurOnEsc: true,
      accessToken: props.mapboxAccessToken
    });
    /*props.onLoading && ctrl.on("loading", props.onLoading);
      props.onResults && ctrl.on("results", props.onResults);
      props.onResult && ctrl.on("result", props.onResult);
      props.onError && ctrl.on("error", props.onError);
      console.log("ctrl", ctrl);*/

    if (geocoder.getBbox() && props !== undefined) {
      if (
        geocoder.getProximity() !== props.proximity &&
        props.proximity !== undefined
      ) {
        geocoder.setProximity(props.proximity);
      }
      if (
        geocoder.getRenderFunction() !== props.render &&
        props.render !== undefined
      ) {
        geocoder.setRenderFunction(props.render);
      }
      if (
        geocoder.getLanguage() !== props.language &&
        props.language !== undefined
      ) {
        geocoder.setLanguage(props.language);
      }
      if (geocoder.getZoom() !== props.zoom && props.zoom !== undefined) {
        geocoder.setZoom(props.zoom);
      }
      if (geocoder.getFlyTo() !== props.flyTo && props.flyTo !== undefined) {
        geocoder.setFlyTo(props.flyTo);
      }
      if (
        geocoder.getPlaceholder() !== props.placeholder &&
        props.placeholder !== undefined
      ) {
        geocoder.setPlaceholder(props.placeholder);
      }
      if (
        geocoder.getCountries() !== props.countries &&
        props.countries !== undefined
      ) {
        geocoder.setCountries(props.countries);
      }
      if (geocoder.getTypes() !== props.types && props.types !== undefined) {
        geocoder.setTypes(props.types);
      }
      if (
        geocoder.getMinLength() !== props.minLength &&
        props.minLength !== undefined
      ) {
        geocoder.setMinLength(props.minLength);
      }
      if (geocoder.getLimit() !== props.limit && props.limit !== undefined) {
        geocoder.setLimit(props.limit);
      }
      if (geocoder.getFilter() !== props.filter && props.filter !== undefined) {
        geocoder.setFilter(props.filter);
      }
      if (geocoder.getOrigin() !== props.origin && props.origin !== undefined) {
        geocoder.setOrigin(props.origin);
      }
      // Types missing from @types/mapbox__mapbox-gl-geocoder
      // if (geocoder.getAutocomplete() !== props.autocomplete && props.autocomplete !== undefined) {
      //   geocoder.setAutocomplete(props.autocomplete);
      // }
      // if (geocoder.getFuzzyMatch() !== props.fuzzyMatch && props.fuzzyMatch !== undefined) {
      //   geocoder.setFuzzyMatch(props.fuzzyMatch);
      // }
      // if (geocoder.getRouting() !== props.routing && props.routing !== undefined) {
      //   geocoder.setRouting(props.routing);
      // }
      // if (geocoder.getWorldview() !== props.worldview && props.worldview !== undefined) {
      //   geocoder.setWorldview(props.worldview);
      // }
    }

    const element = geocoder.onAdd(props.map.getMap());
    divRef.current?.appendChild(element);

    return () => {
      const parentContainer = document.getElementById("geocoder");
      const geoChild = document.getElementsByClassName(
        "mapboxgl-ctrl-geocoder"
      );

      if (!parentContainer || !geoChild) return;
      parentContainer.removeChild(geoChild[0]);
    };
  }, [props]);

  return <div id="geocoder" className="geo-coder" ref={divRef}></div>;
}
